import React from 'react';
import loyaltyLogo from '@/assets/images/loyalty_logo.png';

/**
 * LogoLoader — animated brand loader with spinning rings around the logo.
 *
 * Used during full-screen loading states (session restore, initial auth).
 * Pairs a pulsing logo with two counter-rotating rings and animated bouncing dots.
 */
const LogoLoader = ({ message, fullScreen = true }) => {
  return (
    <div
      className={`flex flex-col justify-center items-center gap-6 bg-gradient-to-b from-white to-gray-50 ${
        fullScreen
          ? 'fixed inset-0 w-screen h-screen z-50'
          : 'w-full min-h-[400px] py-16'
      }`}
      role="status"
      aria-live="polite"
      aria-label={message || 'Loading'}
    >
      <div className="relative flex items-center justify-center w-36 h-36">
        {/* Outer rotating ring */}
        <div
          className="absolute inset-0 rounded-full border-4 border-gray-100 border-t-blue-500 border-r-blue-400 animate-spin"
          style={{ animationDuration: '1.5s' }}
        />
        {/* Inner counter-rotating ring */}
        <div
          className="absolute inset-3 rounded-full border-2 border-gray-100 border-b-blue-300 animate-spin"
          style={{ animationDuration: '2.2s', animationDirection: 'reverse' }}
        />
        {/* Logo with subtle pulse */}
        <img
          src={loyaltyLogo}
          alt="Loading"
          className="w-20 h-20 object-contain animate-pulse"
          style={{ animationDuration: '2s' }}
        />
      </div>

      {message && (
        <div className="flex items-center gap-2">
          <span className="text-gray-600 font-medium">{message}</span>
          <span className="flex gap-1">
            <span
              className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce"
              style={{ animationDelay: '0ms' }}
            />
            <span
              className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce"
              style={{ animationDelay: '150ms' }}
            />
            <span
              className="w-1.5 h-1.5 rounded-full bg-blue-500 animate-bounce"
              style={{ animationDelay: '300ms' }}
            />
          </span>
        </div>
      )}
    </div>
  );
};

export default LogoLoader;
